module.exports = __webpack_public_path__ + "img/step1.1.fd2385b2.svg";